<script setup lang="ts">
    import useBuefy from '@/shared/composables/useBuefy';
    import { useShippingStore } from '@/stores/shippingStore';

    const store = useShippingStore();
    const buefy = useBuefy();

    function formatJson(json: string): string {
        return JSON.stringify(JSON.parse(json), null, 2);
    }

    async function onInspect(): Promise<void> {
        buefy.dialog.alert({
            title: 'Export options used',
            message: `<pre>${formatJson(store.selectedPackage!.extractionOptions)}</pre>`
        });
    }

</script>

<template>
    <b-button
        icon-left="magnify"
        @click="onInspect">
        Export options
    </b-button>
</template>
